module.exports = __webpack_public_path__ + "img/13.27bcc68f.jpg";